<script lang="ts" setup>

	import {DetailView} from '@/enum/detail.view';

	defineProps<{
		detailView: DetailView
	}>();

	const emit = defineEmits(['toggle-view']);

	const toggleView = (view: DetailView) => emit('toggle-view', view);

</script>

<template>
	<a :class="[detailView === DetailView.LIST ? 'active' : '']"
	   class="catalog-overview-header__listview"
	   href="#"
	   @click.stop.prevent="toggleView(DetailView.LIST)">

	<svg class="icon-list-view" height="17" width="18">
			<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#list-view"></use>
		</svg>
	</a>

	<a :class="[detailView === DetailView.GRID ? 'active' : '']"
	   class="catalog-overview-header__gridview"
	   href="#"
	   @click.stop.prevent="toggleView(DetailView.GRID)">

	<svg class="icon-grid-view" height="18" width="18">
			<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#grid-view"></use>
		</svg>
	</a>
</template>
